import { FormHelperText, Stack } from '@mui/material';

import { api } from 'common';

import { OrderDiagnoses } from './OrderDiagnoses';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { OrderProcedures } from '../../AsynchronousJobs/Variants/OrderProcedures';

export function UpdatePatientOrderFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.patientOrderId"
        label="Patient Order Id"
        helperText="Enter the reference to the Patient Order - e.g. `{{patient.data.patientOrderId}}`"
        placeholder="e.g. {{start.data.patientOrderId}}"
      />
      <FormHelperText>The Patient Order ID should be a valid UUID string</FormHelperText>
      <OrderProcedures prefix="config" />
      <OrderDiagnoses prefix="config" />
      <BlockValueTemplateField
        fieldName="config.status"
        label="Status"
        helperText={`Must be one of: ${Object.values(api.PatientOrder.OrderStatus).join(', ')}`}
      />
      <BlockValueTemplateField
        fieldName="config.requestedAppointmentTimePeriodStart"
        label="Requested Appointment Time Period Start"
      />
      <BlockValueTemplateField
        fieldName="config.requestedAppointmentTimePeriodEnd"
        label="Requested Appointment Time Period End"
      />
      <BlockValueTemplateField fieldName="config.specialty" label="Specialty" />
      <BlockValueTemplateField
        fieldName="config.referredByDepartment"
        label="Referred By Department"
      />
      <BlockValueTemplateField
        fieldName="config.referredToDepartment"
        label="Referred To Department"
      />
      <BlockValueTemplateField fieldName="config.reasonForExam" label="Reason For Exam" />
      <BlockValueTemplateField
        fieldName="config.referredByEhrProviderFirstName"
        label="Referred By Provider - First Name"
      />
      <BlockValueTemplateField
        fieldName="config.referredByEhrProviderLastName"
        label="Referred By Provider - Last Name"
      />
      <BlockValueTemplateField
        fieldName="config.referredByEhrProviderValue"
        label="Referred By Provider - EHR Provider ID"
      />
      <BlockValueTemplateField
        fieldName="config.referredByEhrProviderEmail"
        label="Referred By Provider - Email"
      />
      <BlockValueTemplateField
        fieldName="config.referredToEhrProviderFirstName"
        label="Referred To Provider - First Name"
      />
      <BlockValueTemplateField
        fieldName="config.referredToEhrProviderLastName"
        label="Referred To Provider - Last Name"
      />
      <BlockValueTemplateField
        fieldName="config.referredToEhrProviderValue"
        label="Referred To Provider - EHR Provider ID"
      />
      <BlockValueTemplateField
        fieldName="config.referredToEhrProviderEmail"
        label="Referred To Provider - Email"
      />

      <BlockValueTemplateField
        fieldName="config.ehrProviderKind"
        label="EHR Provider Kind"
        helperText={`Must be one of: ${Object.values(api.EhrProviderInformation.Kind).join(', ')}`}
      />
    </Stack>
  );
}
